$(function () {

  var type = $('.type');
  var make = $('.top-make');
  var activeTabs = $('.filter-box [data-toggle=\'tab\']');

  activeTabs.on('click', function () {
    var href = $(this).attr('href');
    href = href.match('-') ? href.slice(0, -2) : href;
    $('.top-make' + ' [href="' + href + '-top"]').click();
    $('.type' + ' [href="' + href + '-bot"]').click();

    setTimeout(function () {
      checkNumberOfMake();
      checkNumberOfTypes();
    }, 200);
  });

  function checkNumberOfTypes() {
    $('.type .tab-pane.active').find('.car-type').length === 0 ?
      type.slideUp() :
      type.slideDown();
  }

  function checkNumberOfMake() {
    $('.top-make .tab-pane.active').find('.top-make-card').length === 0 ?
      make.slideUp() :
      make.slideDown();
  }

  checkNumberOfMake();
  checkNumberOfTypes();
});


// WEBPACK FOOTER //
// ./app/webpacker/src/js/control_index_tabs.js